import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCrown"><Path d="M3.82101 16.8525L1.75 6.75L7.75 10.25L12 3.75L16.25 10.25L22.25 6.75L20.179 16.8525C19.8929 18.2481 18.6647 19.25 17.2401 19.25H6.75989C5.33526 19.25 4.10711 18.2481 3.82101 16.8525Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCrown;
